<script lang="ts" setup>
import MIcon from "../../medicus/MIcon";
import MTooltipBasic from "../../medicus/MTooltipBasic";
import { usePromise } from "vue-composable";
import { hasPermission } from "../../../utils/permission";
import { useKeyboardShortcut } from "../../../composables/keyboardShortcut";
import { openModal } from "../../../composables/dialog/drawer";
import { useApp } from "../../../store";
import { ref, watch } from "vue";

defineProps<{ opened?: Boolean }>();

const app = useApp();
const isOpen = ref(false);
useKeyboardShortcut("patient-finder", () => {
  openSearch();
});

function openSearch() {
  // stop multiple openings by click or shortcut, ENG-15095 (partial fix, just Patient Finder atm)
  if (!isOpen.value) {
    isOpen.value = true;
    return openModal("/staff/recent-patients", {
      ariaLabel: "Find a patient",
      ariaLabelledBy: false,
    });
  }
}

const { loading: checkingPermission, result: hasAccess } = usePromise(() =>
  hasPermission("/staff/recent-patients"),
);

watch(
  () => app.isModalOpen,
  () => {
    isOpen.value = app.isModalOpen;
  },
);
</script>

<template>
  <m-button
    flat
    dense
    data-testid="app-search"
    :disable="checkingPermission || !hasAccess"
    aria-haspopup="dialog"
    :aria-expanded="isOpen"
    :sr-label="!opened ? 'Find a patient' : undefined"
    @click="openSearch"
  >
    <MTooltipBasic v-if="!hasAccess"
      >You don’t have permission to perform this action.</MTooltipBasic
    >
    <m-layout-stack horizontal center full>
      <m-icon name="fa-regular fa-magnifying-glass" />
      <span>Patient Finder</span>
    </m-layout-stack>
  </m-button>
</template>
<style lang="scss">
.modal-wrapper .app-search-modal.modal {
  background-color: var(--surface-default);

  > .modal-header {
    box-shadow: none;
    padding: var(--space-2-5) var(--space-5) 0px var(--space-5);

    > .modal-title {
      font-family: Arial, sans-serif;
      font-style: normal;
      font-weight: 700;
      font-size: var(--font-size-xl);
      line-height: 100%;

      margin: auto 0;
    }
  }
}
</style>
